import React, { useEffect, useState } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLocation, useNavigate } from "react-router";
import QuantityCalculationModal from "./QuantityCalculationModal";
import useQueryParams from "../../../../hooks/useQueryParams";

export default function AvailableQuantityField({
  asset,
  label = "Available Quantity",
  queryParamName = "showQuantityCalculation",
  selectionParamName = null,
  selectionParamValue = null,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useQueryParams();
  const showFromUrl = params.get(queryParamName) === "true";
  const [open, setOpen] = useState(showFromUrl);

  useEffect(() => {
    setOpen(showFromUrl);
  }, [showFromUrl]);

  const updateQueryParamState = shouldOpen => {
    const nextParams = new URLSearchParams(location.search);

    if (shouldOpen) {
      nextParams.set(queryParamName, "true");
      if (selectionParamName && selectionParamValue) {
        nextParams.set(selectionParamName, String(selectionParamValue));
      }
    } else {
      nextParams.delete(queryParamName);
    }

    navigate({ search: nextParams.toString() }, { replace: true });
  };

  const handleOpen = () => {
    if (!asset?.id) return;
    updateQueryParamState(true);
    setOpen(true);
  };

  const handleClose = () => {
    updateQueryParamState(false);
    setOpen(false);
  };

  return (
    <>
      <TextField
        size="small"
        label={label}
        value={asset?.availableQuantity || 0}
        fullWidth
        onClick={handleOpen}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Show quantity calculation"
                edge="end"
                onClick={event => {
                  event.stopPropagation();
                  handleOpen();
                }}
              >
                <InfoOutlinedIcon color="primary" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiInputBase-input": {
            cursor: asset?.id ? "pointer" : "default",
          },
        }}
      />
      {open && <QuantityCalculationModal open={open} asset={asset} onClose={handleClose} />}
    </>
  );
}
